import type { ReactElement } from 'react';

import { useAnchorable } from '../../hooks/useAnchorable';

import { BlueSky } from './components/Bluesky';
import { Instagram } from './components/Instagram';
import { InstagramReel } from './components/InstagramReel';
import { Stocktwits } from './components/Stocktwits';
import { TikTok } from './components/TikTok';
import { Twitter } from './components/Twitter';
import { Youtube } from './components/Youtube';

import type { TServiceEmbedProps } from './ServiceEmbed.types';

const ServiceEmbed = ({ element }: TServiceEmbedProps): ReactElement | null => {
  const { service, data, url, screenshotUrl } = element.attrs || {};
  const { anchorAttributes } = useAnchorable(element.attrs);

  if (service === 'youtube') {
    return <Youtube embedUrl={data?.embed_url} anchorId={anchorAttributes?.id} />;
  }

  if (service === 'twitter') {
    return <Twitter anchorId={anchorAttributes?.id} tweetUrl={url} />;
  }

  if (service === 'tiktok') {
    return (
      <TikTok
        videoId={data?.video_id}
        citeUrl={data?.cite_url}
        authorId={data?.author_id}
        title={data?.title}
        anchorId={anchorAttributes?.id}
      />
    );
  }

  if (service === 'bluesky') {
    return (
      <BlueSky
        oembedHtml={data?.oembed_html}
        threadPostUri={data?.thread_post_uri}
        threadPostCid={data?.thread_post_cid}
        threadContent={data?.thread_content}
        threadUrl={data?.thread_url}
        profileName={data?.profile_name}
        profileUsername={data?.profile_username}
        postedAt={data?.posted_at}
        anchorId={anchorAttributes?.id}
      />
    );
  }

  if (service === 'stocktwits') {
    return (
      <Stocktwits
        dataOrigin={data?.data_origin}
        messageId={data?.message_id}
        messageContent={data?.message_content}
        messageUrl={data?.message_url}
        profileName={data?.profile_name}
        profileUsername={data?.profile_username}
        postedAt={data?.posted_at}
        anchorId={anchorAttributes?.id}
      />
    );
  }

  if (service === 'instagram') {
    if (url?.includes('/reel/')) {
      return <InstagramReel anchorId={anchorAttributes?.id} postUrl={url} screenshotUrl={screenshotUrl} />;
    }

    return <Instagram postUrl={data?.post_url} anchorId={anchorAttributes?.id} screenshotUrl={screenshotUrl} />;
  }

  return null;
};

export { ServiceEmbed };
